import type { FrameVariantBulkPreview } from "@/api/dragon-tiles";
import type { Frame } from "@/types/dragon-tiles";
import type { QueryClient } from "@tanstack/react-query";

export function collectFrameVariantIds(frames: Frame[]): string[] {
  return frames.flatMap((frame) =>
    frame.frame_variants
      .filter((variant) => variant.id)
      .map((variant) => variant.id),
  );
}

export function getVariantPreviewsForFrame(
  frame: Frame,
  bulkPreviews: Record<string, FrameVariantBulkPreview> | undefined,
): Record<string, FrameVariantBulkPreview> {
  const frameVariantPreviews: Record<string, FrameVariantBulkPreview> = {};
  for (const variant of frame.frame_variants) {
    if (variant.id && bulkPreviews?.[variant.id]) {
      frameVariantPreviews[variant.id] = bulkPreviews[variant.id];
    }
  }
  return frameVariantPreviews;
}

export function seedFrameVariantPreviewCache(
  queryClient: QueryClient,
  siteId: string,
  bulkPreviews: Record<string, FrameVariantBulkPreview>,
): void {
  for (const [variantId, preview] of Object.entries(bulkPreviews)) {
    queryClient.setQueryData(
      ["frameVariantPreview", siteId, variantId],
      preview,
    );
  }
}
